import { format, roundToNearestMinutes } from 'date-fns'
import { type FunctionComponent } from 'react'
import { TimeFormats } from '@/common/datepicker/utilities/formats'
import { type InboxThreadEventEventableIncomingFormSubmissionType } from '@/state/entities/inbox/inbox.types'
import { MessageRow } from './message-row'

const ThreadIncomingFormSubmissionBox: FunctionComponent<{
  event: InboxThreadEventEventableIncomingFormSubmissionType
}> = ({ event }) => {
  return (
    <MessageRow
      direction="submission"
      name="Form submission"
      time={format(
        roundToNearestMinutes(event.created_at, { nearestTo: 10 }),
        TimeFormats.FourHourApple
      )}
    >
      <div className="space-y-3">
        {event.entries.map((entry: any, index: number) => {
          const question = (entry.question ?? '').trim()
          // Drop the "Message" (and blank) labels — the answer just reads as the
          // message under the header. Keep labels for other fields.
          const showLabel = question && question.toLowerCase() !== 'message'
          return (
            <div key={`${question}-${index}`} className="space-y-0.5">
              {showLabel ? (
                <p className="text-xs font-medium uppercase tracking-wide text-[var(--muted-foreground)]">
                  {question}
                </p>
              ) : null}
              <p className="text-sm leading-relaxed whitespace-pre-line break-words">
                {entry.answers}
              </p>
            </div>
          )
        })}
      </div>
    </MessageRow>
  )
}

export default ThreadIncomingFormSubmissionBox
